import api from './api';

const cardTransferService = {
  // ==================== Accounts ====================
  getAccounts: async (params = {}) => {
    const response = await api.get('/card-transfers/accounts', { params });
    return response.data;
  },

  getAccount: async (uuid) => {
    const response = await api.get(`/card-transfers/accounts/${uuid}`);
    return response.data;
  },

  createAccount: async (data) => {
    const response = await api.post('/card-transfers/accounts', data);
    return response.data;
  },

  updateAccount: async (uuid, data) => {
    const response = await api.put(`/card-transfers/accounts/${uuid}`, data);
    return response.data;
  },

  depositToAccount: async (uuid, data) => {
    const response = await api.post(`/card-transfers/accounts/${uuid}/deposit`, data);
    return response.data;
  },

  withdrawFromAccount: async (uuid, data) => {
    const response = await api.post(`/card-transfers/accounts/${uuid}/withdraw`, data);
    return response.data;
  },

  setAccountBalance: async (uuid, data) => {
    const response = await api.put(`/card-transfers/accounts/${uuid}/balance`, data);
    return response.data;
  },

  // ==================== Transfers ====================
  getTransfers: async (params = {}) => {
    const response = await api.get('/card-transfers/transfers', { params });
    return response.data;
  },

  createIncomingTransfer: async (data) => {
    const response = await api.post('/card-transfers/transfers/incoming', data);
    return response.data;
  },

  createOutgoingTransfer: async (data) => {
    const response = await api.post('/card-transfers/transfers/outgoing', data);
    return response.data;
  },

  completeTransfer: async (uuid, data) => {
    const response = await api.post(`/card-transfers/transfers/${uuid}/complete`, data);
    return response.data;
  },

  cancelTransfer: async (uuid, data) => {
    const response = await api.post(`/card-transfers/transfers/${uuid}/cancel`, data);
    return response.data;
  },

  // Delete transfer (admin only)
  deleteTransfer: async (uuid) => {
    const response = await api.delete(`/card-transfers/transfers/${uuid}`);
    return response.data;
  },

  // ==================== Reports ====================
  getDailySummary: async (date) => {
    const response = await api.get('/card-transfers/summary/daily', { params: { date } });
    return response.data;
  }
};

export default cardTransferService;
